{
  "organizationLabel": "Organisation:",
  "profileDropdownAccountInfoItem": "Kontoinformationen (intern)",
  "profileDropdownAccountSettingsHeader": "Kontoeinstellungen",
  "profileDropdownProductSettingsHeader": "Produkteinstellungen",
  "profileDropdownUserSettingsItem": "Voreinstellungen",
  "profileLegalNoticesMenuItem": "Rechtliche Hinweise",
  "signOut": "Abmelden",
  "themeInfoTooltip": "Nicht alle Programme unterstützen das dunkle Design.",
  "userProfileName": "{firstName} {lastName}",
  "userThemeSwitchLabel": "Dunkles Design"
}
